// extracted by mini-css-extract-plugin
module.exports = {"mobileStyle":"CoreAddStoredPaymentForm_mobileStyle__3uoeU","webStyle":"CoreAddStoredPaymentForm_webStyle__-KHBO"};